"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REALE_MUTUA = void 0;
exports.REALE_MUTUA = {
    AGRIGENTO: {
        regionCode: 'AG',
        paintLaborRate: 21,
        stripRefitLaborRate: 21,
        repairLaborRate: 21,
        displayLabel: 'Agrigento',
    },
    ALESSANDRIA: {
        regionCode: 'AL',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Alessandria',
    },
    ANCONA: {
        regionCode: 'AN',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Ancona',
    },
    AOSTA: {
        regionCode: 'AO',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Aosta',
    },
    'ASCOLI PICENO': {
        regionCode: 'AP',
        paintLaborRate: 29,
        stripRefitLaborRate: 29,
        repairLaborRate: 29,
        displayLabel: 'Ascoli Piceno',
    },
    "L'AQUILA": {
        regionCode: 'AQ',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: "L'Aquila",
    },
    AREZZO: {
        regionCode: 'AR',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Arezzo',
    },
    ASTI: {
        regionCode: 'AT',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Asti',
    },
    AVELLINO: {
        regionCode: 'AV',
        paintLaborRate: 20,
        stripRefitLaborRate: 20,
        repairLaborRate: 20,
        displayLabel: 'Avellino',
    },
    BARI: {
        regionCode: 'BA',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Bari',
    },
    BERGAMO: {
        regionCode: 'BG',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Bergamo',
    },
    BIELLA: {
        regionCode: 'BI',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Biella',
    },
    BELLUNO: {
        regionCode: 'BL',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Belluno',
    },
    BENEVENTO: {
        regionCode: 'BN',
        paintLaborRate: 20,
        stripRefitLaborRate: 20,
        repairLaborRate: 20,
        displayLabel: 'Benevento',
    },
    BOLOGNA: {
        regionCode: 'BO',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Bologna',
    },
    BRINDISI: {
        regionCode: 'BR',
        paintLaborRate: 25,
        stripRefitLaborRate: 25,
        repairLaborRate: 25,
        displayLabel: 'Brindisi',
    },
    BRESCIA: {
        regionCode: 'BS',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Brescia',
    },
    'BARLETTA ANDRIA TRANI': {
        regionCode: 'BT',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Barletta Andria Trani',
    },
    BOLZANO: {
        regionCode: 'BZ',
        paintLaborRate: 38,
        stripRefitLaborRate: 38,
        repairLaborRate: 38,
        displayLabel: 'Bolzano',
    },
    CAGLIARI: {
        regionCode: 'CA',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Cagliari',
    },
    CAMPOBASSO: {
        regionCode: 'CB',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Campobasso',
    },
    CASERTA: {
        regionCode: 'CE',
        paintLaborRate: 20,
        stripRefitLaborRate: 20,
        repairLaborRate: 20,
        displayLabel: 'Caserta',
    },
    CHIETI: {
        regionCode: 'CH',
        paintLaborRate: 29,
        stripRefitLaborRate: 29,
        repairLaborRate: 29,
        displayLabel: 'Chieti',
    },
    CALTANISSETTA: {
        regionCode: 'CI',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Caltanissetta',
    },
    CUNEO: {
        regionCode: 'CL',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Cuneo',
    },
    COMO: {
        regionCode: 'CN',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Como',
    },
    CREMONA: {
        regionCode: 'CO',
        paintLaborRate: 36,
        stripRefitLaborRate: 36,
        repairLaborRate: 36,
        displayLabel: 'Cremona',
    },
    COSENZA: {
        regionCode: 'CR',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Cosenza',
    },
    CATANIA: {
        regionCode: 'CS',
        paintLaborRate: 22,
        stripRefitLaborRate: 22,
        repairLaborRate: 22,
        displayLabel: 'Catania',
    },
    CATANZARO: {
        regionCode: 'CT',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Catanzaro',
    },
    ENNA: {
        regionCode: 'CZ',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Enna',
    },
    'FORLI CESENA': {
        regionCode: 'EN',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Forli Cesena',
    },
    FERRARA: {
        regionCode: 'FC',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Ferrara',
    },
    FOGGIA: {
        regionCode: 'FE',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Foggia',
    },
    FIRENZE: {
        regionCode: 'FG',
        paintLaborRate: 20,
        stripRefitLaborRate: 20,
        repairLaborRate: 20,
        displayLabel: 'Firenze',
    },
    FERMO: {
        regionCode: 'FI',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Fermo',
    },
    FROSINONE: {
        regionCode: 'FM',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Frosinone',
    },
    GENOVA: {
        regionCode: 'FR',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Genova',
    },
    GORIZIA: {
        regionCode: 'GE',
        paintLaborRate: 42,
        stripRefitLaborRate: 42,
        repairLaborRate: 42,
        displayLabel: 'Gorizia',
    },
    GROSSETO: {
        regionCode: 'GO',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Grosseto',
    },
    IMPERIA: {
        regionCode: 'GR',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Imperia',
    },
    ISERNIA: {
        regionCode: 'IM',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Isernia',
    },
    CROTONE: {
        regionCode: 'IS',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Crotone',
    },
    LECCO: {
        regionCode: 'KR',
        paintLaborRate: 21,
        stripRefitLaborRate: 21,
        repairLaborRate: 21,
        displayLabel: 'Lecco',
    },
    LECCE: {
        regionCode: 'LC',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Lecce',
    },
    LIVORNO: {
        regionCode: 'LE',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Livorno',
    },
    LODI: {
        regionCode: 'LI',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Lodi',
    },
    LATINA: {
        regionCode: 'LO',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Latina',
    },
    LUCCA: {
        regionCode: 'LT',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Lucca',
    },
    'MONZA E DELLA BRIANZA': {
        regionCode: 'LU',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Monza E Della Brianza',
    },
    MACERATA: {
        regionCode: 'MB',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Macerata',
    },
    MESSINA: {
        regionCode: 'MC',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Messina',
    },
    MILANO: {
        regionCode: 'ME',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Milano',
    },
    MANTOVA: {
        regionCode: 'MI',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Mantova',
    },
    MODENA: {
        regionCode: 'MN',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Modena',
    },
    MASSA: {
        regionCode: 'MO',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Massa',
    },
    MATERA: {
        regionCode: 'MS',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Matera',
    },
    NAPOLI: {
        regionCode: 'MT',
        paintLaborRate: 22,
        stripRefitLaborRate: 22,
        repairLaborRate: 22,
        displayLabel: 'Napoli',
    },
    NOVARA: {
        regionCode: 'NA',
        paintLaborRate: 20,
        stripRefitLaborRate: 20,
        repairLaborRate: 20,
        displayLabel: 'Novara',
    },
    NUORO: {
        regionCode: 'NO',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Nuoro',
    },
    ORISTANO: {
        regionCode: 'NU',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Oristano',
    },
    PALERMO: {
        regionCode: 'OG',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Palermo',
    },
    PIACENZA: {
        regionCode: 'OR',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Piacenza',
    },
    PADOVA: {
        regionCode: 'PA',
        paintLaborRate: 25,
        stripRefitLaborRate: 25,
        repairLaborRate: 25,
        displayLabel: 'Padova',
    },
    PESCARA: {
        regionCode: 'PC',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Pescara',
    },
    PERUGIA: {
        regionCode: 'PD',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Perugia',
    },
    PISA: {
        regionCode: 'PE',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Pisa',
    },
    PORDENONE: {
        regionCode: 'PG',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Pordenone',
    },
    PRATO: {
        regionCode: 'PI',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Prato',
    },
    PARMA: {
        regionCode: 'PN',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Parma',
    },
    PISTOIA: {
        regionCode: 'PO',
        paintLaborRate: 37,
        stripRefitLaborRate: 37,
        repairLaborRate: 37,
        displayLabel: 'Pistoia',
    },
    'PESARO E URBINO': {
        regionCode: 'PR',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Pesaro E Urbino',
    },
    PAVIA: {
        regionCode: 'PT',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Pavia',
    },
    POTENZA: {
        regionCode: 'PU',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Potenza',
    },
    RAVENNA: {
        regionCode: 'PV',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Ravenna',
    },
    'REGGIO CALABRIA': {
        regionCode: 'PZ',
        paintLaborRate: 24,
        stripRefitLaborRate: 24,
        repairLaborRate: 24,
        displayLabel: 'Reggio Calabria',
    },
    'REGGIO EMILIA': {
        regionCode: 'RA',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Reggio Emilia',
    },
    RAGUSA: {
        regionCode: 'RC',
        paintLaborRate: 21,
        stripRefitLaborRate: 21,
        repairLaborRate: 21,
        displayLabel: 'Ragusa',
    },
    RIETI: {
        regionCode: 'RE',
        paintLaborRate: 31,
        stripRefitLaborRate: 31,
        repairLaborRate: 31,
        displayLabel: 'Rieti',
    },
    ROMA: {
        regionCode: 'RG',
        paintLaborRate: 25,
        stripRefitLaborRate: 25,
        repairLaborRate: 25,
        displayLabel: 'Roma',
    },
    RIMINI: {
        regionCode: 'RI',
        paintLaborRate: 29,
        stripRefitLaborRate: 29,
        repairLaborRate: 29,
        displayLabel: 'Rimini',
    },
    ROVIGO: {
        regionCode: 'RM',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Rovigo',
    },
    SALERNO: {
        regionCode: 'RN',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Salerno',
    },
    SIENA: {
        regionCode: 'RO',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Siena',
    },
    SONDRIO: {
        regionCode: 'SA',
        paintLaborRate: 22,
        stripRefitLaborRate: 22,
        repairLaborRate: 22,
        displayLabel: 'Sondrio',
    },
    'LA SPEZIA': {
        regionCode: 'SI',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'La Spezia',
    },
    SIRACUSA: {
        regionCode: 'SO',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Siracusa',
    },
    SASSARI: {
        regionCode: 'SP',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Sassari',
    },
    'SUD SARDEGNA': {
        regionCode: 'SR',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Sud Sardegna',
    },
    SAVONA: {
        regionCode: 'SS',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Savona',
    },
    TARANTO: {
        regionCode: 'SU',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Taranto',
    },
    TERAMO: {
        regionCode: 'SV',
        paintLaborRate: 32,
        stripRefitLaborRate: 32,
        repairLaborRate: 32,
        displayLabel: 'Teramo',
    },
    TRENTO: {
        regionCode: 'TA',
        paintLaborRate: 22,
        stripRefitLaborRate: 22,
        repairLaborRate: 22,
        displayLabel: 'Trento',
    },
    TORINO: {
        regionCode: 'TE',
        paintLaborRate: 29,
        stripRefitLaborRate: 29,
        repairLaborRate: 29,
        displayLabel: 'Torino',
    },
    TRAPANI: {
        regionCode: 'TN',
        paintLaborRate: 37,
        stripRefitLaborRate: 37,
        repairLaborRate: 37,
        displayLabel: 'Trapani',
    },
    TERNI: {
        regionCode: 'TO',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Terni',
    },
    TRIESTE: {
        regionCode: 'TP',
        paintLaborRate: 23,
        stripRefitLaborRate: 23,
        repairLaborRate: 23,
        displayLabel: 'Trieste',
    },
    TREVISO: {
        regionCode: 'TR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Treviso',
    },
    UDINE: {
        regionCode: 'TS',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Udine',
    },
    VARESE: {
        regionCode: 'TV',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Varese',
    },
    'VERBANO CUSIO OSSOLA': {
        regionCode: 'UD',
        paintLaborRate: 35,
        stripRefitLaborRate: 35,
        repairLaborRate: 35,
        displayLabel: 'Verbano Cusio Ossola',
    },
    VERCELLI: {
        regionCode: 'VA',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Vercelli',
    },
    VENEZIA: {
        regionCode: 'VB',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Venezia',
    },
    VICENZA: {
        regionCode: 'VC',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Vicenza',
    },
    VERONA: {
        regionCode: 'VE',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Verona',
    },
    VITERBO: {
        regionCode: 'VI',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Viterbo',
    },
    'VIBO VALENTIA': {
        regionCode: 'VR',
        paintLaborRate: 33,
        stripRefitLaborRate: 33,
        repairLaborRate: 33,
        displayLabel: 'Vibo Valentia',
    },
    'MEDIO CAMPIDANO': {
        regionCode: 'VS',
        paintLaborRate: 28,
        stripRefitLaborRate: 28,
        repairLaborRate: 28,
        displayLabel: 'Medio Campidano',
    },
};
//# sourceMappingURL=realemutua.js.map